"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m11.209 15.088-4.172-4.803c-.272-.314-.335-.744-.163-1.122s.538-.613.954-.613h8.344c.416 0 .781.235.953.613a1.04 1.04 0 0 1-.163 1.122l-4.172 4.803a1.05 1.05 0 0 1-1.582 0z"
}), 'ArrowDown');
//# sourceMappingURL=index.js.map